import * as actionTypes from '../action/actions';

export const initialState = {
    dataUser: {},
    dataFamily: {},
    idUser: null
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DATA_USER:
            return {
                ...state,
                dataUser: action.dataUser
            };
        case actionTypes.DATA_FAMILY:
            return {
                ...state,
                dataFamily: action.dataFamily
            };
        case actionTypes.ID_USER:
            return {
                ...state,
                idUser: action.idUser
            };
        default:
            return state;
    }
};
export default userReducer;
